import { createFileRoute } from "@tanstack/react-router";
import { QualityGuardOrganizationSettingsPage } from "@/features/quality-guard/components/quality-guard-config-page";

export const Route = createFileRoute("/settings/quality-guard")({
  component: QualityGuardOrganizationSettingsPage,
});
